import { Option } from '@chillibean/component-library';

export class Action {
  constructor(params = {}) {
    this.name = params.name;
    this.value = params.value;
  }

  multiSelectParams() {
    return new Option(this.name, this.value);
  }

  findByValue(value) {
    return this.value === value;
  }
}
